import _ from 'lodash';

export const collectEditedFieldNames = ({ editedFieldNames, form, seededValues }) =>
  Object.keys(form).reduce((acc, fieldName) => {
    if (_.isEqual(form[fieldName], seededValues[fieldName])) {
      acc.delete(fieldName);

      return acc;
    }

    return acc.add(fieldName);
  }, new Set(editedFieldNames));

export const buildSeededForm = ({ initialFormValues, preservedValues, editedFieldNames }) =>
  Object.keys(initialFormValues).reduce((acc, fieldName) => {
    acc[fieldName] = editedFieldNames.has(fieldName)
      ? preservedValues[fieldName]
      : initialFormValues[fieldName];

    return acc;
  }, {});
